<template>
  <div class="Monitoring">
    <el-row style="height: 100%;">
      <el-col :span="13" style="height: 100%; ">
        <div class="grid-content bg-purple" style="height: 100%;">
          <iframe
            src="http://w.eportinno.com/worldex_wms_www/html/worldex/wmsKanBan/vehicleQueuing_C.html"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="auto"
          ></iframe>
        </div>
      </el-col>
      <el-col :span="11" style="height: 100%;">
        <div class="grid-content bg-purple-light" style="height: 100%;">
          <div class="Monitoring-list1">
            <el-form
              :model="form"
              ref="ruleForm"
              label-width="100px"
              class="Monitoring-tiem demo-ruleForm"
            >
              <el-form-item>
                <el-date-picker
                  class="Monitoring-time1"
                  v-model="form.date1"
                  type="date"
                  placeholder="选择起始日期"
                ></el-date-picker>
                <el-date-picker
                  class="Monitoring-time1"
                  v-model="form.date2"
                  type="date"
                  placeholder="选择截止日期"
                ></el-date-picker>
                <el-button
                  class="Monitoring-time2"
                  type="primary"
                  @click="submitForm('ruleForm')"
                >查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="Monitoring-list2">
            <div
              id="echarts1"
              :style="{  height: '100%' }"
              style="background-color: #fff;padding-top: 5px;padding-left: 5px;"
            ></div>
          </div>
          <div class="Monitoring-list3">
            <div
              id="echarts2"
              :style="{  height: '100%' }"
              style="background-color: #fff;padding-top: 5px;padding-left: 5px;"
            ></div>
          </div>
          <div class="Monitoring-list4">
            <div
              id="echarts3"
              :style="{  height: '100%' }"
              style="background-color: #fff;padding-top: 5px;padding-left: 5px;"
            ></div>
          </div>
          <div class="Monitoring-list5">
            <div
              id="echarts4"
              :style="{  height: '100%' }"
              style="background-color: #fff;padding-top: 5px;padding-left: 5px;"
            ></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        date1: "",
        date2: ""
      },
      unit: {
        max: 0,
        data: []
      },
      unit2: {
        max: 0,
        data: []
      },
      warehouse: [
        {
          num: "社会堆场",
          Single: [
            35,
            19,
            18,
            16,
            47,
            43,
            0,
            25,
            0,
            0,
            0,
            0,
            0,
            46,
            27,
            14,
            0,
            14,
            23,
            57,
            0,
            0,
            34,
            34
          ],
          time: [
            12,
            10,
            12,
            55,
            13,
            18,
            0,
            12,
            0,
            0,
            0,
            0,
            0,
            15,
            15,
            33,
            0,
            60,
            22,
            28,
            0,
            0,
            11,
            14
          ]
        },
        {
          num: "暂落场地",
          Single: [
            24,
            41,
            19,
            23,
            11,
            35,
            47,
            53,
            17,
            0,
            48,
            35,
            0,
            0,
            52,
            24,
            17,
            0,
            23,
            33,
            31,
            0,
            13,
            24
          ],
          time: [
            14,
            61,
            20,
            35,
            15,
            26,
            29,
            15,
            41,
            0,
            22,
            28,
            0,
            0,
            19,
            26,
            45,
            0,
            31,
            40,
            39,
            0,
            18,
            27
          ]
        },
        {
          num: "洋山码头",
          Single: [
            12,
            15,
            37,
            0,
            26,
            11,
            0,
            0,
            27,
            55,
            0,
            0,
            52,
            28,
            0,
            0,
            67,
            0,
            11,
            0,
            0,
            34,
            32,
            0
          ],
          time: [
            33,
            41,
            36,
            0,
            54,
            43,
            0,
            0,
            80,
            52,
            0,
            0,
            45,
            57,
            0,
            0,
            57,
            0,
            78,
            0,
            0,
            41,
            73,
            0
          ]
        },
        {
          num: "社会仓库",
          Single: [
            0,
            14,
            18,
            11,
            23,
            15,
            22,
            0,
            0,
            16,
            43,
            26,
            0,
            49,
            45,
            0,
            0,
            41,
            14,
            14,
            0,
            0,
            44,
            24
          ],
          time: [
            0,
            31,
            20,
            33,
            36,
            20,
            56,
            0,
            0,
            20,
            24,
            46,
            0,
            20,
            18,
            0,
            0,
            24,
            31,
            21,
            0,
            0,
            16,
            21
          ]
        }
      ]
    };
  },
  mounted() {
    for (let i in this.warehouse) {
      this.monit(this.warehouse[i]);
    }
  },
  methods: {
    monit(e) {
      var echarts = require("echarts/lib/echarts");
      require("echarts/lib/chart/line");
      require("echarts/lib/component/title");
      var myChart1 = echarts.init(document.getElementById("echarts1"));
      var myChart2 = echarts.init(document.getElementById("echarts2"));
      var myChart3 = echarts.init(document.getElementById("echarts3"));
      var myChart4 = echarts.init(document.getElementById("echarts4"));

      this.unit.data = e.Single;
      this.unit2.data = e.time;
      var max = 0;
      for (let i in this.unit.data) {
        if (this.unit.data[i] > max) {
          max = this.unit.data[i];
        }
      }
      let tts = 0;
      if (max < 10) {
        tts = 10;
      } else {
        tts = 10 - (max % 10) + max;
      }
      this.unit.max = tts;

      var max2 = 0;
      for (let i in this.unit2.data) {
        if (this.unit2.data[i] > max2) {
          max2 = this.unit2.data[i];
        }
      }
      let tts2 = 0;
      if (max2 < 120) {
        tts2 = 120;
      } else {
        tts2 = 10 - (max2 % 10) + max2;
      }
      this.unit2.max = tts2;
      // 绘制图表
      var option = {
        title: {
          text: "社会堆场",
          textStyle: {
            fontWeight: "normal", //标题颜色
            color: "#515a6e"
          }
        },
        tooltip: {
          trigger: "axis"
        },

        legend: {
          data: ["平均停留", "单量"],
          textStyle: {
            color: "#515a6e"
          }
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          axisPointer: {
            type: "shadow"
          },
          data: [
            "1h",
            "2h",
            "3h",
            "4h",
            "5h",
            "6h",
            "7h",
            "8h",
            "9h",
            "10h",
            "11h",
            "12h",
            "13h",
            "14h",
            "15h",
            "16h",
            "17h",
            "18h",
            "19h",
            "20h",
            "21h",
            "22h",
            "23h",
            "24h"
          ],
          axisLabel: {
            show: true,
            type: "shadow",
            textStyle: {
              color: "#515a6e"
            }
          }
        },
        yAxis: [
          {
            type: "value",
            min: 0,
            max: this.unit2.max,
            interval: this.unit2.max / 6,
            boundaryGap: false,
            nameTextStyle: {
              color: "#515a6e"
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#515a6e"
              }
            },

            axisLabel: {
              formatter: value => {
                //formatter拦截数据展示的方法
                let max = this.unit.data.reduce((a, b) => (a > b ? a : b));
                if (max == 0) {
                  return value;
                } else {
                  value = this.y_axis_data_display(max, value); //该方法是将展示的值转化成小于1024的数据
                  return value + "分钟";
                }
              },
              textStyle: {
                color: "#515a6e"
              }
            }
          },
          {
            type: "value",
            boundaryGap: false,
            min: 0,
            max: this.unit.max,
            interval: this.unit.max / 6,
            nameTextStyle: {
              color: "#515a6e"
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#515a6e"
              }
            },
            axisLabel: {
              formatter: value => {
                //formatter拦截数据展示的方法
                let max = this.unit.data.reduce((a, b) => (a > b ? a : b));
                if (max == 0) {
                  return value;
                } else {
                  value = this.y_axis_data_display(max, value); //该方法是将展示的值转化成小于1024的数据
                  return value + "个";
                }
              },
              textStyle: {
                color: "#515a6e"
              }
            }
          }
        ],
        series: [
          {
            name: "平均停留",
            type: "line",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "blue"
                }
              }
            },
            data: this.unit2.data
          },
          {
            name: "单量",
            type: "bar",
            yAxisIndex: 1,
            barWidth: 15,
            itemStyle: {
              normal: {
                color: "#41c8b6",
                lineStyle: {
                  color: "#da6363"
                }
              }
            },
            data: this.unit.data
          }
        ]
      };
      if (e.num == "社会堆场") {
        myChart1.setOption(option);
      } else if (e.num == "暂落场地") {
        option.title.text = "暂落场地";
        myChart2.setOption(option);
      } else if (e.num == "洋山码头") {
        option.title.text = "洋山码头";
        myChart3.setOption(option);
      } else if (e.num == "社会仓库") {
        option.title.text = "社会仓库";
        myChart4.setOption(option);
      }
    },
    y_axis_data_display(max, value) {
      if (max <= 0) {
        value = "0";
      } else {
        let k = 1024;
        let c = Math.floor(Math.log(max) / Math.log(k));
        if (c == -1) {
          c = 0;
        }
        value = (value / Math.pow(k, c)).toFixed(0);
      }
      return value;
    },

    submitForm() {
      console.log("暂无接口");
    }
  }
};
</script>

<style>
.Monitoring {
  height: 100%;
  background-color: #eee;
}
.Monitoring-list1 {
  height: 85px;
  position: relative;
}
.Monitoring-tiem {
  width: 680px;
  padding-top: 20px;
  position: absolute;
  right: 0px;
}
.Monitoring-time1 {
  margin-right: 10px;
}

.Monitoring-time1 > .el-input__inner {
  border: 1px solid #fff;
  background-color: #fff;
  color: #515a6e !important;
}
.Monitoring-time2 {
  border: 1px solid #fff !important;
  background-color: #fff !important;
  border-radius: 6px !important;
  color: #515a6e !important;
}

.Monitoring-list2 {
  height: 21.5%;
}
.Monitoring-list3 {
  margin-top: 10px;
  height: 21.5%;
}
.Monitoring-list4 {
  margin-top: 10px;
  height: 21.5%;
}
.Monitoring-list5 {
  margin-top: 10px;
  height: 21.5%;
}
</style>


// WEBPACK FOOTER //
// src/views/table/Monitoring.vue